<template>
  <div style="height: 100%; background-color: #f5f6fa">
    <!--    <TopHeader></TopHeader>-->
    <div style="background-color: #f5f6fa; box-sizing: border-box">
      <div class="connet orderDeiltsConnet" v-loading="loading">
        <div class="connetTop">
          <div class="CT_left" @click="back">
            <img src="../../../img/back.png" alt="" />
            <span>返回上一步</span>
          </div>
        </div>
        <div class="box">
          <div class="title">
            <span class="title_icon">&nbsp;</span><span class="titleTxt">挂号信息</span>
          </div>
          <table cellspacing="“0”" class="outTable">
            <tr>
              <td><span>医院</span></td>
              <td>
                <span>{{ Data.hospitalName }}</span>
              </td>
              <td><span>科室</span></td>
              <td>
                <span>{{ Data.deptName }}</span>
              </td>
              <td><span>医生</span></td>
              <td>
                <span>{{ Data.doctorName }}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ Data.doctorLevel }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>挂号单号</span>
              </td>
              <td>
                <span>{{ Data.orderNumber }}</span>
              </td>
              <td><span>挂号时间</span></td>
              <td>
                <span>{{ Data.createTime }}</span>
              </td>
              <td><span>业务类型</span></td>
              <td><span>图文问诊</span></td>
            </tr>
            <tr>
              <td><span>挂号费（元）</span></td>
              <td>
                <span>{{ Data.fee }}</span>
              </td>
              <td><span>状态</span></td>
              <td>
                <span v-if="Data.status == 1" class="status" style="color: #ff7500; background: #ff8d3c24">
                  待支付</span>
                <span v-if="Data.status == 2" class="status" style="color: #bbca41; background: #ebfd5140">待接诊</span>
                <span v-else-if="Data.status == 3" class="status" style="color: #1dc11d; background: #e8f9e8">
                  已完成</span>
                <span v-else-if="Data.status == 4" class="status" style="color:#ff2121; background: #ff21213b">
                  已取消</span>
                <span v-else-if="Data.status == 5" class="status" style="color: #758a99; background: #c3c3c333">
                  退款中</span>
                <span v-else-if="Data.status == 6" class="status" style="color: #685757; background: #e9e7ef">
                  已退款</span>
                <span v-else-if="Data.status == 7" class="status" style="color: #685757; background: #e9e7ef">
                  接诊中</span>
                <span v-else-if="Data.status == 10" class="status" style="color: #685757; background: #e9e7ef">
                  已关闭</span>
              </td>
              <td><span>完成时间</span></td>
              <td>
                <span>{{ Data.prescrOutTime }}</span>
              </td>
            </tr>
            <tr>
              <td><span>就诊人</span></td>
              <td>
                <span>{{ Data.userName }}</span>
              </td>
              <td><span>证件号码</span></td>
              <td>
                <span>{{ idNo }}</span>
              </td>
              <td><span>手机号</span></td>
              <td>
                <span>{{ Data.phone }}</span>
              </td>
            </tr>
            <tr v-if="Data.referrer != null && Data.referrer != ''">
              <td><span>推荐人</span></td>
              <td colspan="5">{{ Data.referrer }}</td>
            </tr>
            <tr>
              <td v-if="Data.advisoryId != null && Data.advisoryId != ''">第三方订单号</td>
              <td v-if="Data.advisoryId != null && Data.advisoryId != ''">{{ Data.advisoryId }}</td>
              <td v-if="Data.exDesc != null && Data.exDesc != ''">第三方异常</td>
              <td colspan="3" v-if="Data.exDesc != null && Data.exDesc != ''">{{ Data.exDesc }}</td>
            </tr>
            <tr v-if="Data.status == 5 || Data.status == 6">
              <td><span>退款原因</span></td>
              <td colspan="5">{{ Data.desc }}</td>
            </tr>
          </table>
        </div>
        <div class="box" v-if="Pay">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title">
                <div class="title collapseTitle">
                  <span class="title_icon">&nbsp;</span><span class="titleTxt">支付信息</span>
                </div>
              </template>
              <table cellspacing="“0”" class="outTable">
                <tr>
                  <td><span>交易状态</span></td>
                  <td>
                    <span v-if="Pay.status == 1" class="status"
                      style="color: #ff7500; background: #ff8d3c24">待支付</span><span v-else-if="Pay.status == 2"
                      class="status" style="color: #1dc11d; background: #e8f9e8">已支付</span>
                    <span v-else-if="Pay.status == 3" class="status"
                      style="color: #758a99; background: #c3c3c333">退款中</span>
                    <span v-else-if="Pay.status == 4" class="status"
                      style="color: #685757; background: #e9e7ef">已退款</span>
                  </td>
                  <td><span>支付方式</span></td>
                  <td>
                    <span v-if="Pay.payType == 1">微信支付</span><span v-else-if="Pay.payType == 2">支付宝支付</span>
                    <span v-else-if="Pay.payType == 3">余额支付</span>
                    <span v-else-if="Pay.payType == 9">医保支付</span>
                  </td>
                  <td><span>支付时间</span></td>
                  <td>
                    <span>{{ Pay.payTime }}</span>
                  </td>
                </tr>
              </table>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 用法用量卡片 -->
        <div class="box" v-if="Data.prescrKind == 2">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="4">
              <template slot="title">
                <div class="title collapseTitle">
                  <span class="title_icon">&nbsp;</span><span class="titleTxt">用法用量</span>
                </div>
              </template>
              <el-table :data="[Data]" style="width: 100%">
                <el-table-column prop="num" label="数量"></el-table-column>
                <el-table-column label="煎药方式">
                  <template slot-scope="scope">
                    <span v-if="scope.row.decoctingMethod == 1">自煎</span>
                    <span v-else-if="scope.row.decoctingMethod == 2">代煎</span>
                    <span v-else-if="scope.row.decoctingMethod == 3">膏方</span>
                    <span v-else-if="scope.row.decoctingMethod == 4">磨粉</span>
                    <span v-else>无</span>
                  </template>
                </el-table-column>
                <el-table-column prop="wayName" label="用法"></el-table-column>
                <el-table-column prop="frquName" label="频次"></el-table-column>
                <el-table-column prop="frquNum" label="每日剂数"></el-table-column>
                <el-table-column prop="frquPreNum" label="每剂分几次使用"></el-table-column>
                <el-table-column label="单次用量">
                  <template slot-scope="scope">
                    {{ scope.row.sinDoscnt }}{{ scope.row.sinDosunt }}
                  </template>
                </el-table-column>
                <el-table-column prop="usageTime" label="用药时间"></el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="box" v-if="drugList">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="3">
              <template slot="title">
                <div class="title collapseTitle">
                  <span class="title_icon">&nbsp;</span><span class="titleTxt">药品信息</span>
                </div>
              </template>
              <el-table :data="drugList" style="width: 100%">
                <!-- 药品类型列 -->
                <el-table-column label="药品类型" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-if="Data.prescrKind == 1" class="statusStyle4">西药</span>
                    <span v-else-if="Data.prescrKind == 2" class="statusStyle2">中药</span>
                    <span v-else>未知</span>
                  </template>
                </el-table-column>
                <el-table-column prop="drugCode" label="药品编码" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="drugName" label="药品名" :show-overflow-tooltip="true">
                </el-table-column>
                <!-- 西药显示规格，中药不显示 -->
                <el-table-column v-if="Data.prescrKind == 1" prop="specification" label="规格"
                  :show-overflow-tooltip="true">
                </el-table-column>
                <!-- 西药显示总量，中药不显示 -->
                <el-table-column v-if="Data.prescrKind == 1" label="总量" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <div>
                      {{
                        scope.row.minPackageQuantity
                      }}{{ scope.row.minPreparationUnit }}/{{
                        scope.row.minPackageUnit
                      }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="drugNumber" label="药品数量" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-if="Data.prescrKind == 2">{{ scope.row.drugNumber }} {{ scope.row.minPackageUnit }}</span>
                    <span v-else>{{ scope.row.drugNumber }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="box" v-if="prescriptionFlag">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="2">
              <template slot="title">
                <div class="title collapseTitle">
                  <span class="title_icon">&nbsp;</span><span class="titleTxt">处方信息</span>
                </div>
              </template>
              <table cellspacing="“0”" class="outTable" style="margin-bottom: 24px">
                <tr>
                  <td><span>处方状态</span></td>
                  <td>
                    <span v-if="prescription.status == 1" class="status" style="color: #ff7500">
                      待审方</span>
                    <span v-else-if="prescription.status == 2" class="status" style="color: #bbca41">待使用</span>
                    <span v-else-if="prescription.status == 3" class="status" style="color: #1dc11d">
                      已使用</span>
                    <span v-else-if="prescription.status == 4" class="status" style="color: #90bfc7">
                      已作废</span>
                    <span v-else-if="prescription.status == 0" class="status" style="color: #758a99">
                      已过期</span>
                    <span v-else-if="prescription.status == 5" class="status" style="color: #1dc11d">
                      使用中</span>
                  </td>
                  <td><span>处方编号</span></td>
                  <td>
                    <span>{{ prescription.hiRxno ? prescription.hiRxno : prescription.prescrNo }}</span>
                  </td>
                  <td><span>开方时间</span></td>
                  <td>
                    <span>{{ Data.updateTime }}</span>
                  </td>
                </tr>
              </table>
              <div class="flexBox roam"
                v-if="prescription.status != 1 && prescription.status != 4 && prescription.status != 0">
                <div></div>
                <div class="flexBox roamButton">
                  <div @click="dialogVisible = true">
                    <span>查看处方</span>
                  </div>
                  <div @click="downLoad(prescription.type, prescription.prescrNo, prescription.hiRxno, Data.selfPlatType)">
                    <span>下载处方</span>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <el-dialog title="电子处方详情" :visible.sync="dialogVisible" width="600px" class="recipelDetails">
          <table>
            <tr>
              <td>
                <span>处方来源：</span><span>{{ prescription.hospitalName }}</span>
              </td>
              <td>
                <span>开方医师：</span><span>{{ prescription.doctorName }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span style="display: inline-block; width: 340px">处方编号：{{ prescription.hiRxno ? prescription.hiRxno :
                  prescription.prescrNo }}</span>
              </td>
              <td>
                <span>开方时间：</span><span>{{ Data.prescrCreateTime }}</span>
              </td>
            </tr>
          </table>
          <div class="borderBox"></div>
          <table class="userBox">
            <tr>
              <td>
                <span>姓名：</span><span>{{ prescription.patientName }}</span>
              </td>
              <td>
                <span>性别：</span><span>{{ ageSex.sex }}</span>
              </td>
              <td>
                <span>年龄：</span><span>{{ ageSex.age }}岁</span>
              </td>
            </tr>
          </table>
          <div class="diagnosisBox diagnosisBox1">
            <p><span class="title_icon">&nbsp;</span>诊断结果</p>
            <p>{{ prescription.diagName }}</p>
          </div>
          <div class="diagnosisBox">
            <p><span class="title_icon">&nbsp;</span>疾病史</p>
            <p>
              <span>{{ Data.diseaseHistory }}</span>
            </p>
          </div>
          <div class="diagnosisBox">
            <p><span class="title_icon">&nbsp;</span>药物过敏史</p>
            <p>
              <span v-if="Data.allergyFlag != 0">{{ Data.allergyName }}</span><span v-else>无</span>
            </p>
          </div>
          <div class="diagnosisBox">
            <p><span class="title_icon">&nbsp;</span>肝功能状态</p>
            <p>
              <span v-if="Data.liverFunction == 'NORMAL'">正常</span>
              <span v-else-if="Data.liverFunction == 'ABNORMAL'">异常</span>
              <span v-else-if="Data.liverFunction == 'UNKOWN'">未知</span>
            </p>
          </div>
          <div class="diagnosisBox">
            <p><span class="title_icon">&nbsp;</span>肾功能状态</p>
            <p>
              <span v-if="Data.renalFunction == 'NORMAL'">正常</span>
              <span v-else-if="Data.renalFunction == 'ABNORMAL'">异常</span>
              <span v-else-if="Data.renalFunction == 'UNKOWN'">未知</span>
            </p>
          </div>
          <div class="medicalList">
            <p style="margin-bottom: 10px">
              <span class="title_icon">&nbsp;</span>RP
            </p>
            <div v-for="(item, index) in prescription.prescriptionDrugList" :key="index">
              <div class="flexBox" style="
                  justify-content: space-between;
                  margin-bottom: 6px;
                  font-weight: 600;
                ">
                <div>
                  <span>{{ item.drugName }}</span><span>{{ item.specification }}</span>
                </div>
                <div>
                  X<span>{{ item.drugNumber }}</span>
                </div>
              </div>
              <div v-if="Data.prescrKind === 1">
                用法用量：{{ item.frquName }}，每次{{
                  item.sinDoscnt
                }}{{ item.sinDosunt }}，{{ item.wayName }}
              </div>
            </div>
          </div>
          <div v-if="Data.prescrKind === 2" class="medicalList">
            用法用量：{{ Data.frquName }}，每次{{
              Data.sinDoscnt
            }}{{ Data.sinDosunt }}，{{ Data.wayName }}
          </div>
          <div class="borderBox"></div>
          <div class="tips">
            <span>!</span><span>本处方仅限{{ prescription.pharmacyName }}使用！</span>
          </div>
          <div class="foote">
            <p>备注：</p>
            <p>处方仅在您所处的开放药店3日有效</p>
            <p>
              为保障您的权益，按照监管部门要求，电子处方的部分信息已加密脱敏
            </p>
          </div>
        </el-dialog>
        <!--        <el-dialog-->
        <!--            :visible.sync="payDialog"-->
        <!--            width="660px"-->
        <!--            class="eventDialog payDialog"-->
        <!--            title="选择支付方式"-->
        <!--        >-->
        <!--          <p>支付金额</p>-->
        <!--          <p>-->
        <!--          <span style="font-size: 24px; font-weight: 600">¥</span-->
        <!--          ><span style="font-size: 32px; font-weight: 600">{{ Data.fee }}</span>-->
        <!--          </p>-->
        <!--          <div class="flexBox">-->
        <!--            <div @click="payLoad(2)" class="PayimgBox" v-loading="loading1">-->
        <!--              <i class="iconfont icon-alipay zfbIcon"></i>-->
        <!--              <p class="txt">支付宝支付</p>-->
        <!--            </div>-->
        <!--            <div-->
        <!--                @mouseover="vxHover"-->
        <!--                @mouseout="vxChange"-->
        <!--                class="PayimgBox"-->
        <!--                @click="payLoad(1)"-->
        <!--                v-loading="loading1"-->
        <!--            >-->
        <!--              <img :src="vxImg" alt=""/>-->
        <!--              <p class="txt">微信支付</p>-->
        <!--            </div>-->
        <!--            <div @click="payLoad(3)" class="PayimgBox" v-loading="loading1">-->
        <!--              <i class="iconfont icon-yue zfbIcon"></i>-->
        <!--              <p class="txt">余额支付</p>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </el-dialog>-->
        <!--        <el-dialog-->
        <!--            :visible.sync="payWay_VX"-->
        <!--            width="600px"-->
        <!--            class="eventDialog payDialog payDialog2"-->
        <!--            title="支付问诊费"-->
        <!--            @close="handleCancle"-->
        <!--        >-->
        <!--          <div class="flexBox">-->
        <!--            <div class="left">-->
        <!--              <div ref="QR_code"></div>-->
        <!--            </div>-->
        <!--            <div class="right">-->
        <!--              <div>-->
        <!--                <i-->
        <!--                    class="iconfont icon-alipay"-->
        <!--                    style="-->
        <!--                  color: #0caf60;-->
        <!--                  font-size: 22px;-->
        <!--                  vertical-align: text-top;-->
        <!--                  margin-right: 8px;-->
        <!--                "-->
        <!--                    v-if="payType == 2"-->
        <!--                ></i>-->
        <!--                <img v-else src="../../../img/微信.png" alt=""/><span-->
        <!--                  v-if="payType == 2"-->
        <!--              >支付宝支付</span-->
        <!--              ><span v-else>微信支付</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <span>支付剩余时间：</span><span>{{ countdown }}</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <span>支付金额：</span><span>¥</span><span>{{ Data.fee }}</span>-->
        <!--              </div>-->
        <!--              <p>支付成功后将跳转候诊室，若未跳转请点击下</p>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div-->
        <!--              class="footButton"-->
        <!--              @click="payStatus"-->
        <!--              v-loading="loading2"-->
        <!--              style="cursor: pointer"-->
        <!--          >-->
        <!--            <span>已完成支付</span>-->
        <!--          </div>-->
        <!--        </el-dialog>-->
        <el-dialog :visible.sync="outFlag" width="30%" :show-close="false" class="tipsMsgBox" :modal="false">
          <span style="font-size: 20px; font-weight: 800">
            {{ errorMsg }}
          </span>
        </el-dialog>
      </div>
    </div>
    <div class="bottom footeBox">
      <div></div>
      <!--      <el-button type="success" @click="buttonEvent(3)" v-if="Data.status == 1">立即支付</el-button>-->
      <el-button type="success" @click="goChatHistory">查看记录</el-button>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import { getsocketUrl } from "@/utils/index";
import { parseIdCard } from "@/utils/idCard";
import TopHeader from "@/components/layout/Header.vue";
import { detailsData, downLoadPdf, payGet, payPre } from "@/api/index";

export default {
  components: {
    TopHeader,
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      Data: {},
      prescription: {},
      loading: true,
      outFlag: false,
      errorMsg: "",
      pdfPath: "",
      dialogVisible: false,
      ageSex: {
        sex: "",
        age: "",
      },
      prescriptionFlag: false,
      idNo: "",
      refundFlag: false,
      refundForm: {
        reasonCode: "",
        desc: "",
      },
      rules: {
        reasonCode: [
          { required: true, message: "请选择退款原因", trigger: "change" },
        ],
      },
      vxImg: require("../../../img/vx.png"),
      ybImg: require("../../../img/yb.png"),
      payDialog: false,
      payWay_VX: false,
      loading1: false,
      countdown: "10:00",
      loading2: false,
      deleteFlag: false,
      Pay: {},
      payType: "",
      timer: "",
      socketUrl: getsocketUrl(),
      socket_init: null,
      socketFlag: false,
      heartCheck: null,
      lockReconnect: true,
      reconnectFlag: false,
      reconnectCount: 0,
      initFLag: false,
      initCount: 0,
      drugList: [],
    };
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    back() {
      this.$router.push("/order");
    },
    loadData() {
      let postData = {
        id: localStorage.getItem("detailsId"),
      };
      detailsData(postData).then((data) => {
        if (data.code == 0) {
          this.loading = false;
          this.Data = data.data.reversePrescriptionOrder;
          this.Pay = data.data.reversePrescriptionOrderDetailsPayDTO;
          this.drugList = data.data.orderDrugList;
          if (data.data.prescription) {
            this.prescription = data.data.prescription;
            this.prescriptionFlag = true;
          } else {
            this.prescriptionFlag = false;
          }
          this.ageSex.age = parseIdCard(this.Data.idNo, 3, data.data.reversePrescriptionOrder.userAge);
          this.ageSex.sex = parseIdCard(this.Data.idNo, 2, null, data.data.reversePrescriptionOrder.userSex);
          this.maskedIdCard();
        } else {
          this.loading = false;
          this.outFlag = true;
          this.errorMsg = data.msg;
          setTimeout(() => {
            this.outFlag = false;
          }, 2000);
        }
      });
    },
    downloadfun(file_name, file_path) {
      var ajax = new XMLHttpRequest();
      ajax.open("GET", file_path, true);
      ajax.setRequestHeader("Cache-Control", "no-cache");
      ajax.setRequestHeader("Access-Control-Allow-Origin", "*");
      ajax.responseType = "blob";
      ajax.onload = (e) => {
        let res = e.target.response;
        let blob = new Blob([res]);
        let aLink = document.createElement("a");
        aLink.download = file_name; // 下载文件的名字
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
      };
      ajax.send();
    },
    downLoad(type, prescrNo, hiRxno, selfPlatType) {
      let postData = {
        prescrNo: prescrNo,
      };
      if (prescrNo) {
        let downLoadName;

        // 根据selfPlatType设置文件扩展名
        let fileExtension = "pdf";
        if (selfPlatType === 2) {
          fileExtension = "jpg";
        }

        if (type == 1 && hiRxno) {
          downLoadName = hiRxno.split("/")[hiRxno.split("/").length - 1] + "." + fileExtension;
        } else {
          downLoadName = prescrNo.split("/")[prescrNo.split("/").length - 1] + "." + fileExtension;
        }

        downLoadPdf(postData).then((data) => {
          if (data.code == 0) {
            let mimeType = "image/pdf";
            if (selfPlatType === 2) {
              mimeType = "image/jpeg";
            }

            let downLoadPath = "data:" + mimeType + ";base64," + data.data;
            this.downloadfun(downLoadName, downLoadPath);
          } else {
            this.outFlag = true;
            this.errorMsg = data.msg;
            setTimeout(() => {
              this.outFlag = false;
            }, 2000);
          }
        });
      }
    },
    maskedIdCard() {
      this.idNo = this.Data.idNo;
    },
    buttonEvent(type) {
      if (type == 0) {
        this.deleteFlag = true;
      }
      if (type == 1) {
        this.refundFlag = true;
      }
      if (type == 2) {
        this.setData();
      }
      if (type == 3) {
        this.payDialog = true;
      }
    },
    setData() {
      localStorage.setItem("MR_data", JSON.stringify(this.Data));
      localStorage.setItem("ageSex", JSON.stringify(this.ageSex));
      this.$router.push("/chatHistory");
    },
    vxHover() {
      this.vxImg = require("../../../img/vxHover.png");
    },
    vxChange() {
      this.vxImg = require("../../../img/vx.png");
    },
    Countdown(data) {
      clearInterval(this.timer);
      let endTime =
        data.expireTime.substring(0, 4) +
        "-" +
        data.expireTime.substring(4, 6) +
        "-" +
        data.expireTime.substring(6, 8) +
        " " +
        data.expireTime.substring(8, 10) +
        ":" +
        data.expireTime.substring(10, 12) +
        ":" +
        data.expireTime.substring(12, 14);
      endTime = new Date(endTime).getTime();
      let startTime = new Date(data.localTime).getTime();
      let timeCount = (endTime - startTime) / 1000;
      let minutes = "0";
      let seconds = "0";
      minutes = parseInt(timeCount / 60);
      seconds = parseInt(timeCount - minutes * 60);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      this.countdown = minutes + ":" + seconds;
      this.timer = setInterval(() => {
        timeCount--;
        minutes = parseInt(timeCount / 60);
        seconds = parseInt(timeCount - minutes * 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        if (timeCount < 60) {
          minutes = "00";
        }
        this.countdown = minutes + ":" + seconds;
        if (timeCount === 0) {
          clearInterval(this.timer);
          this.payWay_VX = false;
        }
      }, 1000);
    },
    // payLoad(type) {
    //   this.loading1 = true;
    //   setTimeout(() => {
    //     this.loading1 = false;
    //   }, 10000);
    //   this.payType = type;
    //   let postData = {
    //     orderNumber: this.Data.orderNumber,
    //     payType: type,
    //     source: 1
    //   };
    //   payPre(postData).then((data) => {
    //     if (data.code == 0) {
    //       if (type != 3) {
    //         this.loading1 = false;
    //         this.payDialog = false;
    //         this.payWay_VX = true;
    //         this.vx_QR_code = data.data.qrCode;
    //         this.$nextTick(() => {
    //           this.$refs.QR_code.innerHTML = ""; //二维码清除
    //           new QRCode(this.$refs.QR_code, {
    //             text: this.vx_QR_code, //二维码链接，参数是否添加看需求
    //             width: 160, //二维码宽度
    //             height: 160, //二维码高度
    //             colorDark: "#333333", //二维码颜色
    //             colorLight: "#ffffff", //二维码背景色
    //             correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
    //           });
    //         });
    //         this.Countdown(data.data);
    //       } else if (type == 3) {
    //         this.loading1 = false;
    //         let ageSex = {
    //           age: "",
    //           sex: "",
    //         };
    //         ageSex.age = this.idCard(
    //             data.data.reversePrescriptionOrder.idNo,
    //             3
    //         );
    //         ageSex.sex = this.idCard(
    //             data.data.reversePrescriptionOrder.idNo,
    //             2
    //         );
    //         localStorage.setItem("ageSex", JSON.stringify(ageSex));
    //         localStorage.setItem(
    //             "MR_data",
    //             JSON.stringify(data.data.reversePrescriptionOrder)
    //         );
    //         this.$router.push("/chatHistory");
    //       }
    //     } else {
    //       this.loading1 = false;
    //       this.outFlag = true;
    //       this.errorMsg = data.msg;
    //       setTimeout(() => {
    //         this.outFlag = false;
    //       }, 2000);
    //     }
    //     this.loading1 = false;
    //   });
    // },
    // payStatus() {
    //   this.loading2 = true;
    //   let postData = {
    //     orderNumber: this.Data.orderNumber,
    //   };
    //   setTimeout(() => {
    //     this.loading2 = false;
    //   }, 10000);
    //   payGet(postData).then((data) => {
    //     if (data.code == 0) {
    //       this.loading2 = false;
    //       if (data.data.status == 2) {
    //         this.setData();
    //       } else {
    //         this.outFlag = true;
    //         this.errorMsg = "未检测到支付成功，请稍后再试";
    //         setTimeout(() => {
    //           this.outFlag = false;
    //         }, 2000);
    //       }
    //     } else {
    //       this.outFlag = true;
    //       this.errorMsg = data.msg;
    //       this.loading2 = false;
    //       setTimeout(() => {
    //         this.outFlag = false;
    //       }, 2000);
    //     }
    //   });
    // },
    TipMsg() {
      this.outFlag = true;
      this.errorMsg = "该功能开发中，敬请期待";
      setTimeout(() => {
        this.outFlag = false;
      }, 2000);
    },
    handleCancle() {
      var that = this;
      that.reconnectFlag = true;
      if (!that.lockReconnect) {
        that.initCount = 0;
        that.socket_init.close();
        that.socketFlag = false;
        that.lockReconnect = true;
        that.reconnectFlag = true;
        clearInterval(that.heartCheck);
      }
    },
    goChatHistory() {
      let MR_data = JSON.stringify(this.Data);
      let age = parseIdCard(this.Data.idNo, 3, this.Data.userAge);
      let sex = parseIdCard(this.Data.idNo, 2, null, this.Data.userSex);
      let ageSex = JSON.stringify({
        age: age,
        sex: sex,
      });
      localStorage.setItem("ageSex", ageSex);
      localStorage.setItem("MR_data", MR_data);
      this.$router.push("/chatHistory");
    },
  },
  beforeDestroy() {
    let that = this;
    that.handleCancle();
  },
};
</script>
<style scoped>
.flexBox {
  display: flex;
}

.orderDeiltsConnet {
  box-sizing: border-box;
}

.status {
  /* padding: 4px 6px; */
  font-size: 14px;
  border-radius: 6px;
}

.connet {
  min-height: 100%;
  /* width: 100%; */
  background: #f5f6fa;
  padding: 0px 32px;
  padding-bottom: 58px;
  /* padding-bottom: 45px; */
}

.connetTop {
  padding: 24px 0px;
  /* width: 100%; */
  display: flex;
  overflow: auto;
  justify-content: space-between;
}

.CT_left {
  box-sizing: border-box;
  padding: 11px 0px;
  padding-left: 16px;
  width: 140px;
  /* height: 44px; */
  background: #ffffff;
  border-radius: 8px;
  /* padding: 0px 0px; */
  cursor: pointer;
}

.CT_left:active {
  color: #0caf60;
}

.CT_left img,
.CT_right img {
  margin-right: 4px;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

.title_icon {
  margin-right: 6px;
  width: 4px;
  height: 20px;
  background: #0caf60;
  border-radius: 3px;
}

.box {
  margin-bottom: 24px;
  padding: 26px 20px;
  border-radius: 12px;
  background: #ffffff;
}

.title {
  margin-bottom: 16px;
}

.collapseTitle {
  margin-bottom: 0px;
}

.title_icon {
  margin-right: 8px;
  width: 4px;
  height: 20px;
  background: #0caf60;
  border-radius: 3px;
}

.titleTxt {
  font-size: 18px;
  font-weight: 600;
}

.outTable {
  width: 100%;
  border-collapse: collapse;
}

.outTable>tr>td {
  padding: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  border: 1px solid #eeeff2;
}

.outTable>tr>td:nth-child(2n + 1) {
  width: 170px;
  color: rgba(0, 0, 0, 0.85);
  background: rgba(12, 175, 96, 0.04);
}

.outTable>tr>td:nth-child(2n) {
  /* background: rgba(12, 175, 96, 0.04); */
  min-width: 272px;
}

.box /deep/ .el-collapse {
  border: 0px;
}

.box /deep/ .el-collapse-item__header {
  /* padding-top: 10px; */
  border: 0px;
}

.box /deep/ .el-collapse-item__wrap {
  border: 0px;
}

.roam {
  justify-content: space-between;
}

.roam :nth-child(1) {
  line-height: 36px;
}

.roamButton>div {
  border-radius: 8px;
  cursor: pointer;
}

.roamButton>div>span {
  padding: 0px 24px;
  display: inline-block;
  line-height: 36px;
}

.roamButton>div:nth-child(1) {
  margin-right: 16px;
  border: 1px solid #0caf60;
  color: #0caf60;
}

.roamButton>div:nth-child(1):active {
  color: #86d6af;
  border-color: #86d6af;
}

.roamButton>div:nth-child(2) {
  background: #0caf60;
  color: #fff;
}

.roamButton>div:nth-child(2):active {
  background: #86d6af;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.recipelDetails /deep/ .el-dialog {
  border-radius: 12px;
}

.recipelDetails /deep/ .el-dialog__body {
  padding-top: 16px;
  padding-bottom: 24px;
}

.recipelDetails table {
  width: 100%;
}

.recipelDetails table tr {
  line-height: 28px;
}

.recipelDetails table td span {
  font-size: 14px;
}

.recipelDetails table td span:nth-child(1) {
  color: rgba(0, 0, 0, 0.65);
}

.recipelDetails table td span:nth-child(2) {
  color: rgba(0, 0, 0, 0.85);
}

.borderBox {
  margin: 10px 0px;
  border-top: 1px solid #eeeff2;
  border-bottom: 1px solid #eeeff2;
  height: 10px;
}

.userBox {
  margin-bottom: 10px;
}

.userBox td span:nth-child(2) {
  font-size: 16px;
}

.diagnosisBox p:nth-child(1) {
  margin-bottom: 10px;
}

.diagnosisBox p:nth-child(2) {
  margin-bottom: 10px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}

.recipelDetails .tips {
  margin-bottom: 10px;
  color: #faad14;
}

.recipelDetails .tips span:nth-child(1) {
  margin-right: 4px;
  padding: 0px 7px;
  color: #fff;
  background: #faad14;
  border-radius: 50%;
  display: inline-block;
}

.recipelDetails .foote {
  color: rgba(0, 0, 0, 0.65);
  line-height: 24px;
}

.status {
  padding: 4px 6px;
  font-size: 12px;
}

.footeBox {
  position: fixed;
  bottom: 0px;
  right: 10px;
  background: #fff;
  width: 100%;
  padding: 18px 32px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  z-index: 100
}

.footeBox .el-button {
  margin-right: 20px;
}

.eventDialog /deep/ .el-dialog__body {
  padding-top: 0px;
}

.eventDialog .icon {
  margin-right: 16px;
  padding: 0px 8px;
  border-radius: 50%;
  background: #faad14;
  color: #fff;
}

.eventDialog /deep/ .el-dialog__close {
  color: #a0aec0;
}

.eventDialog /deep/ .el-button {
  border-radius: 8px;
}

.eventDialog /deep/ .el-dialog {
  border-radius: 12px;
}

.eventDialog /deep/ .el-dialog__header {
  background: none;
}

.eventDialog .headTxt {
  line-height: 48px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 18px;
}

.eventDialog .tips {
  padding: 0px;
  color: rgba(0, 0, 0, 0.65);
}

.eventDialog .confirmButton {
  border: 0px;

  background: #0caf60;
}

.eventDialog /deep/ .el-button--primary:active {
  border: 0px;
  background: #86d6af;
}

.eventDialog .closeButton {
  border: 1px solid #eeeff2;
}

.payDialog /deep/ .el-dialog__body {
  padding: 28px 48px;
}

.payDialog /deep/ .el-dialog__title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.payDialog p:nth-child(1) {
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 16px;
}

.payDialog p:nth-child(2) {
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 16px;
  color: #ff7820;
}

.payDialog .tips {
  margin-bottom: 0px;
  font-size: 14px;
  color: #ff4d4f;
}

.payDialog .flexBox {
  justify-content: space-between;
}

.PayimgBox {
  margin-bottom: 16px;
  margin-right: 24px;
  padding: 12px 48px;
  border: 1px solid #eeeff2;
  border-radius: 8px;
  cursor: pointer;
}

.PayimgBox:last-child {
  margin-right: 0px;
}

.PayimgBox:hover {
  color: #0caf60;
  border-color: #0caf60;
}

.PayimgBox img {
  margin-bottom: 8px;
}

.payDialog .PayimgBox>.txt {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.45);
}

.payDialog .PayimgBox:hover .txt {
  color: #0caf60;
}

.payDialog2 {
  padding: 32px 24px;
}

.payDialog2 .footButton {
  text-align: center;
  color: #0caf60;
}

.payDialog2 .footButton span {
  display: inline-block;
  padding: 0px 55px;
  border: 1px solid #0caf60;
  border-radius: 8px;
  line-height: 44px;
}

.payDialog2 .right>div:nth-child(1) {
  margin-bottom: 20px;
}

.payDialog2 .right>div:nth-child(1)>img {
  margin-right: 8px;
  width: 24px;
  height: 24px;
  vertical-align: middle;
}

.payDialog2 .right>div:nth-child(1)>span {
  color: rgba(0, 0, 0, 0.85);
}

.payDialog2 .right>div:nth-child(2) {
  margin-bottom: 32px;
}

.payDialog2 .right>div:nth-child(2)>span {
  color: #ff7820;
}

.payDialog2 .right>div:nth-child(2)>span:first-child {
  color: rgba(0, 0, 0, 0.85);
}

.payDialog2 .right>div:nth-child(3) {
  margin-bottom: 16px;
}

.payDialog2 .right>div:nth-child(3)>span:nth-child(2) {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
}

.payDialog2 .right>div:nth-child(3)>span:nth-child(3) {
  font-size: 32px;
  color: rgba(0, 0, 0, 0.85);
}

.payDialog2 .right p {
  margin-bottom: 42px;
  color: rgba(0, 0, 0, 0.65);
}

.zfbIcon {
  margin-bottom: 8px;
  display: block;
  text-align: center;
  font-size: 35px;
}

.bottom {
  position: fixed;
  bottom: 0px;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 32px;
  background: #fff;
}
</style>